
export const unwrapData = (res: any): any => {
  const body = res?.data ?? res;
  if (body && typeof body === "object" && !Array.isArray(body)) {
    if ("data" in body) return body.data;
    if ("body" in body) return body.body;
  }
  return body;
};

export const unwrapList = <T,>(res: any): Array<T> => {
  const data = unwrapData(res);
  return Array.isArray(data) ? data : [];
};

export const unwrapPage = <T,>(
  res: any
): { content: Array<T>; totalElements: number } => {
  const data = unwrapData(res);
  if (Array.isArray(data)) {
    return { content: data, totalElements: data.length };
  }
  if (data && typeof data === "object" && Array.isArray(data.content)) {
    const totalElements =
      typeof data.totalElements === "number" ? data.totalElements : data.content.length;
    return { content: data.content, totalElements };
  }
  return { content: [], totalElements: 0 };
};

export const formatDateArray = (
  value: unknown,
  options: { withTime?: boolean } = {}
): string => {
  if (value == null) return "-";

  if (Array.isArray(value) && value.length >= 3 && value.every((v) => typeof v === "number")) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = value;
    const date = new Date(year, (month || 1) - 1, day, hour, minute, second);
    if (Number.isNaN(date.getTime())) return "-";
    const hasTime = value.length > 3 && (options.withTime ?? true);
    return hasTime
      ? date.toLocaleString(undefined, {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : date.toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "2-digit",
        });
  }

  const date = new Date(value as any);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
};

export const getErrorMessage = (err: any, fallback: string): string => {
  return (
    err?.friendlyMessage ||
    err?.response?.data?.message ||
    (typeof err?.message === "string" ? err.message : "") ||
    fallback
  );
};

const IMAGE_BASE_URL = (process.env.REACT_APP_IMAGE_BASE_URL || "").trim();

export const resolveImageUrl = (value?: string | null): string => {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  if (/^(https?:|blob:|data:)/i.test(trimmed))
    return trimmed;
  if (!IMAGE_BASE_URL) return trimmed;
  const prefix = IMAGE_BASE_URL.endsWith("/") ? IMAGE_BASE_URL : `${IMAGE_BASE_URL}/`;
  const path = trimmed.startsWith("/") ? trimmed.slice(1) : trimmed;
  return `${prefix}${path}`;
};

export const getMediaSrc = (media: { col1?: string; dataUrl?: string } | null | undefined): string => {
  if (!media) return "";
  return resolveImageUrl(media.col1 || media.dataUrl);
};
